
import Vue from "vue"
import {Prop} from "vue-property-decorator"
import Component from "vue-class-component"
import {MetricAggregated} from "@/cube/metric-data"

@Component({})
export default class ProgressBar extends Vue {
  @Prop() metricData: MetricAggregated

  get amount() {
    return this.metricData.end?.amount
  }

  get totalAmount() {
    return this.metricData.end?.totalAmount
  }

  get amountPercent() {
    return this.metricData.end?.amountPercent ?? 0
  }

  get title() {
    return this.metricData.title
  }
}
